module.exports = __webpack_public_path__ + "resources/img/sp_checkbox.ccdb63bfd70f64d23d59b6c972f17cbc.png";